import { makeAutoObservable } from "mobx";

class PopupStore {
  redeemCoupon = false;
  paymentGateway = false;
  creditsPoints = null;
  imageCapture = false;
  getMoreCredits = false;
  mobileVerfication = false;
  referAndEarn = false;
  connectPopup = false;
  companyBasedInterview = false;
  request = false;
  microPhone = 1;
  KnowMore = false;
  client = false;
  verify = false;
  requestPermission = false;
  requestPermissionPopUp = false;
  allowScreenRecord = false;
  testMedia = true;
  testMediaOpeningThroughSettings = false;
  showPrecautions = false;
  compiler = false;
  interview = false;
  createinterview = false;
  topicbasedinterview = false;
  companyInterview = false;
  Recomended = false;
  popup = false;
  mail = false;
  interview = false;
  shareScreen = false;
  loginWarning = false;
  notification = false;
  experience = false;
  Mcq = false;
  generate = false;
  addResumes = false;
  inverviewdetails = false;
  alert = false;
  emailPopup = false;
  message = "";
  facingProblem = false;
  labelInfoPopup = false;
  labelPopup = false;
  labelEditPopup = false;
  labelTableSkillsPopup = false;
  videoPopup = false;
  ResumeCard = false;
  PurchasePopup = false;
  pdfview = false;
  mailTypePopup = false;
  mailPopup = false;
  successPopup = false;
  alertIcon = "";
  alertPopup = false;
  alertMessage = "";
  alertTitle = "";
  alertButton = "";
  previousInterviews = false;
  ShowResumeCard = false;
  Remainder = false;
  mail2 = false;
  mediaPopup = false;
  mediaType = null;
  mediaUrl = null;
  issueReportPopup = false;
  setIssueReportPopup = (value) => {
    this.issueReportPopup = value;
  };
  setImageCapture = (value) => {
    this.imageCapture = value;
  };
  setMediaPopup = (value) => {
    this.mediaPopup = value;
  };
  setMediaType = (value) => {
    this.mediaType = value;
  };
  setMediaUrl = (value) => {
    this.mediaUrl = value;
  };
  setMail2 = (value) => {
    this.mail2 = value;
  };
  setRemainder = (value) => {
    this.Remainder = value;
  };
  setShowResumeCard = (value) => {
    this.ShowResumeCard = value;
  };
  setPreviousInterviews = (value) => {
    this.previousInterviews = value;
  };
  setAlertIcon(value) {
    this.alertIcon = value;
  }
  setAlertPopup(value) {
    this.alertPopup = value;
  }
  setAlertMessage(value) {
    this.alertMessage = value;
  }
  setAlertTitle(value) {
    this.alertTitle = value;
  }
  setAlertButton(value) {
    this.alertButton = value;
  }
  setSuccessPopup(value) {
    this.successPopup = value;
  }
  setMailPopup(value) {
    this.mailPopup = value;
  }
  setMailTypePopup(value) {
    this.mailTypePopup = value;
  }
  setPdfView(value) {
    this.pdfview = value;
  }
  setPurchasePopup(value) {
    this.PurchasePopup = value;
  }
  setResumeCard(value) {
    this.ResumeCard = value;
  }
  setAddResumes(value) {
    this.addResumes = value;
  }
  setVideoPopup(value) {
    this.videoPopup = value;
  }
  setRequest(value) {
    this.request = value;
  }
  setLabelInfoPopup(value) {
    this.labelInfoPopup = value;
  }
  setMicroPhone(value) {
    this.microPhone = value;
  }
  setLabelTableSkillsPopup(value) {
    this.labelTableSkillsPopup = value;
  }
  setLabelEditPopup(value) {
    this.labelEditPopup = value;
  }
  setLabelPopup(value) {
    this.labelPopup = value;
  }
  setEditLabelPopup(value) {
    this.labelEditPopup = value;
  }
  title = "";
  setTitle(value) {
    this.title = value;
  }
  setFaccingProblem(value) {
    this.facingProblem = value;
  }
  setMessage(val) {
    this.message = val;
  }
  setInterviewDetails = (val) => {
    this.inverviewdetails = val;
  };
  setAlert(val) {
    this.alert = val;
  }
  setEmailPopup(val) {
    this.emailPopup = val;
  }
  setGenerate = (val) => {
    this.generate = val;
  };
  setRecomended = (val) => {
    this.Recomended = val;
  };
  setInterview = (val) => {
    this.interview = val;
  };
  setMail = (value) => {
    this.mail = value;
  };
  setClient = (value) => {
    this.client = value;
  };
  setVerify = (value) => {
    this.verify = value;
  };
  setMcq = (value) => {
    this.Mcq = value ?? false;
  };
  setExperience = (value) => {
    this.experience = value ?? false;
  };
  setLoginWarning = (value) => {
    this.loginWarning = value ?? false;
  };

  setShareScreen = (value) => {
    this.shareScreen = value ?? false;
  };

  setPopup = (value) => {
    this.popup = value ?? false;
  };

  setCompanyInterview = (value) => {
    this.companyInterview = value ?? false;
  };

  setTopicBasedInterview = (value) => {
    this.topicbasedinterview = value ?? false;
  };

  setCreateInterview = (value) => {
    this.createinterview = value ?? false;
  };

  setInterview = (value) => {
    this.interview = value ?? false;
  };

  setShowPrecautions = (value) => {
    this.showPrecautions = value ?? false;
  };

  setTestMedia = (value) => {
    this.testMedia = value ?? false;
  };

  setTestMediaOpeningThroughSettings = (value) => {
    this.testMediaOpeningThroughSettings = value ?? false;
  };

  setCompiler = (value) => {
    this.compiler = value ?? false;
  };

  setRequestPermission = (value) => {
    this.requestPermission = value ?? false;
  };

  setRequestPermissionPopUp = (value) => {
    this.requestPermissionPopUp = value ?? false;
  };

  setAllowScreenRecord = (value) => {
    this.allowScreenRecord = value ?? false;
  };

  setKnowMore = (value) => {
    this.KnowMore = value ?? false;
  };

  setMobileVerfication = (value) => {
    this.mobileVerfication = value ?? false;
  };

  setGetMoreCredits = (value) => {
    this.getMoreCredits = value ?? false;
  };

  setRedeemCoupon = (value) => {
    this.redeemCoupon = value ?? false;
  };

  setPaymentGateway = (value) => {
    this.paymentGateway = value ?? false;
  };

  setCreditPoints(value) {
    this.creditsPoints = value ?? null;
  }

  setReferAndEarn = (value) => {
    this.referAndEarn = value ?? false;
  };

  setConnectPopup = (value) => {
    this.connectPopup = value ?? false;
  };

  setNotification = (value) => {
    this.notification = value ?? false;
  };

  setCompanyBasedInterview = (value) => {
    this.companyBasedInterview = value ?? false;
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export default PopupStore;
